// page_key values MUST match chat-agent catalog.py `_PAGE_KEYS`.
const PERSONAS =
  'admin|agency|carrier|cowbell|customer|da|mssp|pool|premiumprocessor|reinsurer';

export interface DwellPageMatch {
  readonly pageKey: string;
  readonly view: string;
  readonly entityType?: string;
  readonly entityId?: string;
}

interface DwellPageRule {
  readonly pattern: RegExp;
  readonly pageKey: string;
  readonly view: string;
  readonly entityType: string;
}

// First match wins; entity id required; matches any tab. Policy/Quote excluded.
const DWELL_PAGE_RULES: readonly DwellPageRule[] = [
  {
    pattern: new RegExp(`^/(?:${PERSONAS})/inbox/([\\w-]+)`),
    pageKey: 'uw_review',
    view: 'UW Review',
    entityType: 'uw-review',
  },
  {
    pattern: new RegExp(`^/(?:${PERSONAS})/claims/detail/([\\w-]+)`),
    pageKey: 'claim_detail',
    view: 'Claims',
    entityType: 'claim',
  },
  {
    // quotes/requestQuote put the product segment before the submission id;
    // summary/quote put the id first. Group 1 is always the submission id.
    pattern: new RegExp(
      `^/(?:${PERSONAS})/submissions/(?:(?:quotes|requestQuote)/[\\w-]+|summary|quote)/([\\w-]+)`
    ),
    pageKey: 'submission_detail',
    view: 'Submission Details',
    entityType: 'submission',
  },
];

export function matchDwellPage(pathname: string): DwellPageMatch | null {
  for (const rule of DWELL_PAGE_RULES) {
    const match = pathname.match(rule.pattern);
    if (match) {
      return {
        pageKey: rule.pageKey,
        view: rule.view,
        entityType: rule.entityType,
        entityId: match[1] || '',
      };
    }
  }
  return null;
}
